export const iconFontAwesomeDevicesHardwareMobile = (
	<i className="fa-solid fa-mobile"></i>
);
